import CPanel from './CPanel'
import CPanelContent from './CPanelContent'
import CPanelAction from './CPanelAction'

export default {
  components: {
    CPanel,
    CPanelContent,
    CPanelAction
  },
  props: {
    user: {
      type: Object,
      required: true
    }
  }
}
